import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { HStack, Heading, Link, VStack } from "@chakra-ui/react";

import { SerialNumberSearch } from "@components";
import { Layout } from "./PageLayouts";

const SEARCH_HEADER_TEXT =
  "Search for a module, component, or other serialized component:";

export function HomePage() {
  return (
    <Layout variant="centered">
      <VStack gap="32px">
        <Heading as="h2" size="md">
          {SEARCH_HEADER_TEXT}
        </Heading>
        <SerialNumberSearch />
        <HStack w="100%" justifyContent="space-around">
          <Link as={ReactRouterLink} to="/modules">
            View Modules
          </Link>
          <Link as={ReactRouterLink} to="/auxiliary-components">
            View Auxiliary Components
          </Link>
          <Link as={ReactRouterLink} to="/modules/new">
            Start New Module
          </Link>
          <Link as={ReactRouterLink} to="/upnext">
            View Up Next
          </Link>
          <Link as={ReactRouterLink} to="/import-cern-db">
            Import CERN DB Info
          </Link>
          <Link as={ReactRouterLink} to="/make-reports">
            Make Reports
          </Link>
        </HStack>
      </VStack>
    </Layout>
  );
}
